import { useCallback, useEffect } from 'react';
import { useInvokeFunction, useToggleComponent } from 'navigation-components/platform/hooks';
import { IN_APP_HELP_COMPONENT, inAppHelpNavComponentDef } from 'navigation-components/config';
import { captureException } from '../../../utils/sentryAPI';
import { getInAppHelpQueryParams } from '../utils/helpUrlUtils';
export const useToggleHelpWidget = options => {
  const {
    onToggleWidget
  } = options || {};
  const {
    toggle,
    onToggle
  } = useToggleComponent(IN_APP_HELP_COMPONENT);
  const {
    invoke
  } = useInvokeFunction(inAppHelpNavComponentDef);

  // Calls onToggleWidget callback
  useEffect(() => {
    const unsubscribe = onToggle(open => {
      if (onToggleWidget) {
        onToggleWidget(open);
      }
    });
    return () => {
      unsubscribe();
    };
  }, [onToggle, onToggleWidget]);
  const toggleHelpWidget = useCallback(toggleOptions => {
    const {
      shouldOpen,
      route = '',
      queryParamsToDelete = [],
      reopen = false
    } = toggleOptions || {};
    toggle(shouldOpen);
    const queryParams = getInAppHelpQueryParams(reopen, !route);
    invoke('navigate', {
      route,
      queryParamsToDelete,
      queryParams
    }).catch(captureException);
  }, [invoke, toggle]);
  return {
    toggleHelpWidget,
    onToggle
  };
};